export default __webpack_public_path__ + "static/media/art-pro-red-banner-3.69d3a77b.jpg";